import React from "react";
import { Bar } from "react-chartjs-2";
import { Box, Paper } from "@mui/material";

const StatsBarChart = (props) => {
  const { labels, priamryPlayerData, groupAvg, chartName, name } = props;

  const data = {
    labels: labels,
    datasets: [
      {
        label: name,
        data: priamryPlayerData,
        backgroundColor: "rgb(186 28 28 / 87%)", // Customize the bar color
        borderColor: "rgb(186 28 28 / 87%)", // Customize the bar border color
        borderWidth: 1, // Customize the bar border width
      },
      {
        label: "Comparision Group",
        data: groupAvg,
        backgroundColor: "rgb(32 66 132)",
        borderColor: "rgb(32 66 132)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    scales: {
      x: {
        ticks: {
          autoSkip: false, // Ensure all labels are shown
          maxRotation: 0, // Rotate labels to fit if needed
          padding: 10, // Add padding between ticks and labels
        },
        beginAtZero: true,
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    responsive: true,
    layout: {
      padding: 10,
    },
    elements: {
      bar: {
        barPercentage: 0.5, // Adjust the width of the bars (0.5 means 50% of available space)
      },
    },
    interaction: {
      intersect: false, // Disable hover interaction
    },
    aspectRatio: priamryPlayerData?.length === 1 ? 3 : 2, // Set a fixed aspect ratio
  };

  return (
    <Box mt={2} mb={2}>
      <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5" }}>
        <div style={{ textAlign: "center" }}>
          <h3>{chartName}</h3>
        </div>
        <Box sx={{ maxWidth: "400px", maxHeight: "400px", margin: "auto" }}>
          <Bar data={data} options={options} width={"500px"} height={"180px"} />
        </Box>
      </Paper>
    </Box>
  );
};

export default StatsBarChart;
